export default {
    page_title: "Kevi | Base de Contactos",
    base_name: "Base de Contactos",
    export: "Exportar",
    create_segment: "Crear segmento",
    add_contact: "Agregar Contacto",
    import: "Importar",
    import_question: "Que informacion desea importar?",
    sales: "Ventas",
    clients: "Clientes",
    columns: {
        name: "Nombre",
        phone: "Telefono",
        birthday: "Cumpleanos",
        average_ticket: "Ticket Promedio",
        spent: "Gastos",
        orders_made: "Pedidos Realizados",
        email: "E-mail",
        id: "ID",
        external_id: "ID Externo",
    },
    open_contact_aria: "Abrir contacto {0} {1}",
    years_old: "años",
    not_informed: "No informado",
    details: "Detalles",
    filters: {
        bought_in_period: "Compro en el periodo",
        registration_date: "Fecha de registro",
        search: "Nombre, telefono, e-mail o codigo",
        client_segment: "Segmento del cliente",
        first_order_period: "Periodo del primer pedido",
    },
    empty_state: {
        title: "Base de Contactos",
        subtitle: "Todavia no tiene ningun cliente registrado",
    },
    export_headers: {
        name: "Nombre",
        phone: "Telefono",
        birthday: "Cumpleanos",
        age: "Edad",
        email: "E-mail",
        average_ticket: "Ticket Promedio (R$)",
        spent: "Gastos (R$)",
        orders_made: "Pedidos Realizados",
        id: "Id",
        external_id: "Id externo",
    },
    detail: {
        confirm_delete_order_title:
            "¿Está seguro de que desea eliminar el Pedido?",
        confirm_delete_custom_event_title:
            "¿Está seguro de que desea eliminar el Evento Personalizado",
        confirm_delete_event_body:
            "Este evento será eliminado tan pronto como se confirme.",
        edit_order: "Editar Pedido",
        made_order_of: "Realizó un pedido de",
        register_order: "Registrar Pedido",
        back: "Volver",
        more_segments: "{0} más",
        see_less: "ver menos",
        insights: "Insights",
        integration_id: "ID Integración:",
        subscribed: "Suscrito:",
        sms: "SMS",
        whatsapp: "WhatsApp",
        total_quotations: "Número de Presupuestos :",
        total_points: "Total de Puntos :",
        total_orders: "Número de compras:",
        average_ticket: "Ticket Promedio:",
        clv: "Gasto Acumulado (CLV):",
        next_order_prediction: "Previsión próxima compra:",
        replenishment: "Reposición ({0}):",
        view_one_opinion: "Ver 1 opinión.",
        view_many_opinions: "Ver {0} opiniones.",
        edit: "Editar",
        timeline: "Línea de tiempo",
        notes: "Observaciones",
        page_title: "Kevi | Detalle del cliente",
        phonetrack_call: "Llamada vía phonetrack",
        audio_not_supported_prefix:
            "Su navegador no soporta el elemento",
        utm_source: "Utm source:",
        utm_medium: "Utm medium:",
        utm_campaign: "Utm campaign:",
        gclid: "Gclid:",
        campaign_interaction: "Interactuó con campaña",
        left_feedback: "Dejó opinión",
        with_average: "con promedio",
        using_form: "Usando el formulario:",
        redeemed_bonus_of: "Rescató el bono de",
        exchanged: "Cambió",
        for: "por",
        left_segment: "Salió del",
        entered_segment: "Entró en el",
        segment: "segmento",
        added: "Agregamos",
        removed: "Removimos",
        automation: "Automatización:",
        generated_coupon_for: "Cupón generado para",
        code: "código",
        delivery: "Delivery",
        order_cancelled: "Pedido cancelado",
        status: "Estado:",
        products: "Productos:",
        earned: "Ganó:",
        send_now: "Enviar Ahora",
        status_failed: "Fallo en el envío",
        status_failed_with_period: "Fallo en el envío.",
        status_scheduled: "Agendado",
        status_processing: "Procesando",
        status_accepted: "Aceptado",
        status_sent: "Enviado",
        reason: "Motivo:",
        quotation_status_expired: "Expirado",
        quotation_status_rejected: "Rechazado",
        loading_preview: "Cargando vista previa...",
        registered_event: "registró el evento",
        branch: "Sucursal:",
        task_completed: "Tarea completada",
        due_date: "Fecha de vencimiento:",
        suggested_message: "Mensaje sugerido:",
        created_task: "Creó la tarea",
        quotation: "Presupuesto",
        has_quotation_of: "Tiene un presupuesto de",
        order_placed_on: "Pedido realizado en",
        add_note_placeholder: "Agregar observación...",
        add: "Agregar",
        in_a: "en una",
        opinion: "opinión",
        delete_client_title: "¿Desea eliminar este cliente?",
        delete_client_body:
            "Esta acción es irreversible y eliminará permanentemente este cliente y todos los datos vinculados a él.",
        delete_client_button: "Eliminar Cliente",
        notification_sent_success: "Notificación enviada con éxito",
        notification_send_error_prefix: "Error al enviar notificación: ",
        unknown_error: "Error desconocido",
        fail_reason_not_subscribed: "Cliente no suscrito",
        fail_reason_not_enough_credits: "Falta de créditos",
        client_deleted_success: "¡Cliente eliminado con éxito!",
        client_delete_error: "Error al eliminar cliente.",
        point_singular: " punto",
        point_plural: " puntos",
        ai_error: "Error al obtener respuesta de la IA.",
        not_found: "No encontrado",
        storage_load_error: "No se pudo cargar el estado de los grupos de localStorage",
        storage_save_error: "No se pudo guardar el estado de los grupos en localStorage",
    },
    deletion: {
        started: "¡Eliminación de clientes iniciada!",
        error: "Error al iniciar la eliminación de clientes",
    },
    basic: {
        subscribed_channels: "Canales suscritos",
        close: "Cerrar",
        save: "Guardar",
        first_name: "Nombre",
        last_name: "Apellido",
        birthdate: "Fecha de nacimiento",
        register_event: "Registrar evento",
        run_manual_automation: "Disparar automatización",
        create_task: "Crear tarea",
        include_orders: "Incluir Pedidos",
        create_single_form_link: "Crear Enlace de Formulario Único",
        manage_points: "Incluir/Remover Puntos",
        segments: "Segmentos",
        see_more: "Ver más",
        search: "Buscar",
        total_segments: "Total de segmentos: {0}",
        delete: "Eliminar",
    },
    manual_automation: {
        title: "Disparar automatización",
        automation_label: "¿Qué automatización?",
        automation_placeholder: "Seleccione la automatización",
        date_placeholder: "Seleccione la fecha",
        empty: "Ninguna automatización de disparo manual activa.",
        cancel: "Cancelar",
        confirm: "Disparar",
        success: "Automatización disparada con éxito.",
        error: "No se pudo disparar la automatización.",
    },
    modals: {
        delete_client_title: "Eliminar Cliente",
        delete_info_irreversible: "Eliminar el cliente de la base es una acción irreversible.",
        delete_info_will_delete: "Junto con el cliente eliminaremos:",
        delete_info_all_sales: "Todas sus ventas",
        delete_info_all_tasks: "Todas sus tareas",
        delete_info_all_messages: "Todos los mensajes enviados",
        delete_info_all_records: "Cualquier registro vinculado a este cliente",
        delete_info_permanent: "Esta eliminación es permanente.",
        delete_info_inconsistency: "Eliminar el cliente puede generar inconsistencia en los datos",
        delete_info_inconsistency_detail: ", desde el momento en que elimina el cliente, los informes de Kevi ya no reflejarán los mismos números que su ERP.",
        delete_info_confirm_phrase_placeholder: "ELIMINAR {0} PERMANENTEMENTE",
        delete_client_confirm: "¿Estás seguro de que deseas eliminar este cliente?",
        delete_client_body: "Todos los datos de este cliente se eliminarán permanentemente. Esta acción no se puede deshacer.",
        delete_client_button: "Eliminar",
        client_updated_success: "¡Cliente actualizado con éxito!",
        client_updated_error: "Error al actualizar el cliente.",
        manage_points: "Incluir/Remover puntos",
        current_value: "Valor Actual:",
        changed_value: "Valor alterado:",
        close: "Cerrar",
        apply: "Aplicar",
        create_single_form_link: "Crear Enlace de Formulario Único",
        generated_link: "Enlace Generado",
        form: "Formulario",
        select_form: "Seleccione el formulario",
        generate_link: "Generar Enlace",
        create_task_title: "Crear una Tarea",
        title: "Título",
        task_title_placeholder: "Dé un título para esta tarea",
        client: "Cliente",
        assignee: "Responsable",
        select_assignee: "Seleccione un responsable",
        due_date: "Plazo",
        select_due_date: "Seleccione un plazo",
        description: "Descripción",
        task_description_placeholder: "Describa esta tarea",
        cancel: "Cancelar",
        create_task_action: "Crear tarea",
        edit_data: "Editar Datos",
        new_contact: "Nuevo Contacto",
        create_contact: "Crear Contacto",
        subscriptions: "Canales de Envío",
        main_info: "Información Principal",
        integration_id: "ID Integración",
        first_name: "Nombre",
        mobile: "Celular",
        birthdate_placeholder: "dd/mm/yyyy",
        client_created_success: "¡Contacto creado con éxito!",
        client_updated_success: "¡Contacto actualizado con éxito!",
    },
    timeline: {
        search: "Buscar",
        open_all: "Abrir todos",
        close_all: "Cerrar todos",
        showing_range: "Mostrando {0}-{1} de {2}",
        delete: "Eliminar",
        order_created: "Pedido realizado",
        order_fields: "Campos del Pedido:",
        order_created_label: "Pedido realizado:",
        email_subject: "Asunto:",
        whatsapp_message: "mensaje por WhatsApp",
        sms_message: "mensaje por SMS",
        rcs_message: "mensaje por RCS",
        visited_site_from: "Visitó el sitio a partir de",
        ad: "un anuncio",
        generated_coupon: "Cupón generado",
        with_code: "con el código",
        earned_points: "Ganó",
        lost_points: "Perdió",
        ai_basic: "Básico",
        ai_advanced: "Avanzado",
        ai_generated_content: "La IA generó contenido",
        view_execution_details: "Ver detalles de la ejecución",
        instruction: "Instrucción:",
        tool_calls: "Llamadas de herramientas ({0})",
        arguments: "Argumentos:",
        result: "Resultado:",
        unknown_event: "Evento desconocido:",
        field_update_failed: "Error al actualizar campos del cliente",
        field_update_failed_reason: "Motivo:",
        empty_title: "No se encontraron eventos",
        empty_subtitle:
            "No se registraron interacciones para este cliente con los filtros actuales.",
        waiting: "Esperando",
        scheduled_feminine: "Agendada",
        failed_of: "Falló al",
        received: "Recibió",
        pending: "Pendiente",
        sent_to_another_contact: "Enviado a",
        sent_to_another_contact_help:
            "Esta notificación se envió a un contacto distinto del teléfono o correo registrado en este cliente.",
    },
    insights: {
        ai_title: "Kevi IA en tu atención",
        ai_subtitle:
            "Pide resúmenes, entiende el sentimiento del cliente y recibe sugerencias de respuesta en tiempo real.",
        type_message: "Escribe aquí tu mensaje",
        send: "Enviar",
        purchases: "Compras",
        first_purchase: "Primera compra",
        last_purchase: "Última compra",
        most_purchased_item: "Artículo más comprado",
        cumulative_spend: "Gasto acumulado",
        total_purchases: "Total de compras",
        replenishment: "Reposición",
        replenishment_overdue: "Hace {0} días",
        replenishment_today: "Hoy",
        replenishment_tomorrow: "Mañana",
        replenishment_in_days: "En {0} dias",
        validity_range: "Validez entre: {0} a {1}",
        periods: {
            "30_days": "30 días",
            "90_days": "90 días",
            "180_days": "180 días",
            "1_year": "1 año",
            "all_time": "Todo el período",
        },
        view_all: "Ver todos",
        view_latest: "Ver últimos",
        with_stock: "Con stock",
        without_stock: "Sin stock",
        communications: "Comunicaciones",
        contacts: "Contactos",
        last_contact_date: "Fecha del último contacto",
        first_contact_date: "Fecha del primer contacto",
        points: "Puntos",
        available_points: "Puntos disponibles",
        total_accumulated: "Total acumulado",
        points_used: "Puntos usados",
        reward: "Recompensa",
        forms: "Respuestas",
        create_unique_link: "Crear enlace único",
        latest_forms: "Últimas respuestas",
        view: "Visualizar",
        answered: "Respondido",
        not_answered: "No Respondido",
        no_forms_sent: "Ninguna respuesta",
        no_forms_sent_subtitle:
            "Cuando el cliente responda un formulario, la respuesta aparece aquí. También puedes crear un enlace único.",
        tasks: "Tareas",
        generated: "Generadas",
        completed: "Completadas",
        conversion: "Conversión",
        completed_on_time: "Completadas a tiempo",
        latest_tasks: "Últimas tareas",
        completed_single: "Completada",
        pending_single: "Pendiente",
        kevi_coupons: "Cupones Kevi",
        active_coupons: "Cupones Activos",
        used_coupons: "Cupones usados",
        expired_coupons: "Cupones vencidos",
        latest_coupons: "Últimos cupones",
        added: "Añadido",
        removed: "Removido",
        used: "Utilizado",
        expired: "Vencido",
        available: "Disponible",
        pending_plural: "Pendientes",
        completed_plural: "Completadas",
    },
    journey: {
        back: "Volver",
        title: "Jornada del cliente",
        move_to_which_board: "¿A qué tablero quieres mover?",
        move_to_which_stage: "¿Mover a qué etapa?",
        cancel: "Cancelar",
        enter: "Entrar",
        move_success: "Cliente movido con éxito",
        outside_journey: "Fuera de la Jornada: {0}",
        move_action: "Mover {0}",
        move_to_action: "Mover {0} a {1}",
        move_completed_success: "¡Movimiento realizado con éxito!",
    },
    leads: {
        title: "Leads",
        add: "Agregar",
        no_leads_found: "No se encontraron leads",
        page_title: "Kevi | Lista de Leads",
    },
    importer: {
        sending_data: "Enviando datos, esto puede tardar unos minutos...",
        import_success: "¡Importación completada con éxito!",
        import_error: "Ocurrió un error al procesar la importación.",
        queued_message: "¡Importación enviada! Se procesará en segundo plano.",
        queued_link: "Seguir en el historial de importaciones",
        cancel: "Cancelar",
        import: "Importar",
        close: "Cerrar",
        file_size_error: "El archivo excede el tamaño máximo de {0} KB.",
    },
    notes: {
        add_note: "Agregar observación",
        markdown_hint: "Use Markdown para formatear su texto.",
        note_placeholder: "Escriba su observación",
        save_note: "Guardar nota",
        client_notes: "Observaciones del cliente",
        no_notes: "Ninguna observación todavía",
        no_notes_subtitle: "Registre información importante sobre el cliente para facilitar futuros servicios.",
        create_first_note: "Crear primera observación",
        save_error: "Error al guardar: {0}",
    },
};
